import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import { useLocation } from 'react-router-dom';
import Sidebar, { DRAWER_WIDTH } from './Sidebar';
import TopBar from './TopBar';

const PAGE_TITLES = {
  '/': 'Dashboard',
  '/master-data': 'Master Data',
  '/prices': 'Price Management',
  '/excel': 'Material Excel',
  '/header-config': 'Header Configuration',
  '/estimation': 'New Estimation',
  '/estimation-history': 'Estimation History',
  '/accessory-prices': 'Accessory Price Management',
  '/material-accessories': 'Material–Accessories',
  '/accessory-excel': 'Accessory Excel Import / Export',
  '/admin/users': 'User Management',
  '/admin/groups': 'Groups & Permissions',
  '/admin/audit-logs': 'Audit Logs',
};

const AppLayout = ({ children }) => {
  const location = useLocation();
  const title = PAGE_TITLES[location.pathname] || 'Material Master';

  // Sidebar is a fixed-width in-flow column on desktop but an off-canvas
  // overlay drawer below the md breakpoint (see Sidebar.jsx) — this is the
  // shared open/close state for that drawer, toggled by TopBar's hamburger.
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  // Close the drawer automatically on navigation — otherwise it stays open
  // over the new page's content after tapping a nav link.
  useEffect(() => {
    setMobileSidebarOpen(false);
  }, [location.pathname]);

  return (
    <Box sx={{ display: 'flex', height: '100vh', overflow: 'hidden', background: 'linear-gradient(135deg, #EEF2FF 0%, #F1F5FF 50%, #F0F7FF 100%)' }}>
      <Sidebar mobileOpen={mobileSidebarOpen} onClose={() => setMobileSidebarOpen(false)} />
      <TopBar title={title} onMenuClick={() => setMobileSidebarOpen((v) => !v)} />
      <Box
        id="main-scroll"
        component="main"
        sx={{
          flexGrow: 1,
          width: { xs: '100%', md: `calc(100% - ${DRAWER_WIDTH}px)` },
          height: '100vh',
          overflow: 'auto',
        }}
      >
        <Toolbar sx={{ minHeight: '60px !important' }} />
        <Box sx={{ p: 3 }}>{children}</Box>
      </Box>
    </Box>
  );
};

export default AppLayout;
